var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === `permissions`)?_c('div',[_vm._v("You do not have permission to access this page.")]):_c('div',[_vm._v("An error has been encountered.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }